






















import Vue, { PropType } from "vue"
import TopBoard from "./TopBoard.vue"
import { CorporationAccountView } from "~/backendApis/viewModel"

export default Vue.extend({
  components: {
    TopBoard,
  },
  props: {
    corporationAccount: {
      type: Object as PropType<CorporationAccountView>,
      required: true,
    },
  },
  computed: {
    corporationLogoImagePath(): string {
      return this.corporationAccount.logoImage
        ? this.$clHelpers.thumbnail.generateURL({
            image: this.corporationAccount.logoImage,
            width: 150,
            height: 150,
          })
        : ""
    },
  },
})
